import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, forwardRef, useImperativeHandle } from 'react';
import classnames from 'classnames';
import { IconButton } from "../Button/IconButton/IconButton";
import styles from "./Slideout.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Slideout = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    _ref$closeLabel = _ref.closeLabel,
    closeLabel = _ref$closeLabel === void 0 ? 'Click to close.' : _ref$closeLabel,
    _ref$logo = _ref.logo,
    logo = _ref$logo === void 0 ? null : _ref$logo,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? function () {} : _ref$onOpen,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    closed = _useState2[0],
    setClosed = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    closing = _useState4[0],
    setClosing = _useState4[1];
  var onClosingComplete = function onClosingComplete() {
    setClosing(false);
    onClose();
  };
  var handleStateChange = function handleStateChange(close) {
    setClosed(close);
    setClosing(close);
    if (close) {
      setTimeout(onClosingComplete, 500);
    } else {
      onOpen();
    }
  };
  var openSlideout = function openSlideout() {
    handleStateChange(false);
  };
  var closeSlideout = function closeSlideout() {
    handleStateChange(true);
  };
  var toggleSlideout = function toggleSlideout() {
    handleStateChange(!closed);
  };
  useImperativeHandle(forwardedRef, function () {
    return {
      openSlideout: openSlideout,
      closeSlideout: closeSlideout,
      toggleSlideout: toggleSlideout
    };
  });
  return /*#__PURE__*/_jsxs("div", {
    className: classnames({
      [styles.wrapper]: true,
      [styles.closed]: closed,
      [styles.closing]: closing
    }),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.backdrop,
      onClick: closeSlideout
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.slideout,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.logoWrapper,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.logo,
          children: logo
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.content,
        children: children
      }), /*#__PURE__*/_jsx(IconButton, {
        "aria-label": closeLabel,
        icon: "close",
        onClick: closeSlideout,
        size: "15px",
        className: styles.close
      })]
    })]
  });
});